import React from "react";
import FeatureCard from "../FeatureCard";

export default () => (
  <FeatureCard
    isLocked
    to="https://support.skyward.com/files/sites/ProfessionalServices/Skyward-eCommerce-Integration-5.30.23.pdf"
    image="/static/img/Card-ReadTheDocumentation.png"
    imageAlt="A path marked on a map"
    description="View Skyward's eCommerce document"
    loggedOutDescription="Log in to View Skyward's eCommerce document"
    isExternalLink
  >
    Interested in an eCommerce integration? Review and complete this document to get started.
  </FeatureCard>
);
